export const adjustAmtDefaultValues = {
  isIncrease: null,
  isPercent: false,
  amount: null,
};
